module.exports = __webpack_public_path__ + "media/images/home/call-8f80d9d6eedd6cffabaa14940f4b8871.png";